module.exports = __webpack_public_path__ + "static/media/envelope-at.03e87ff0.svg";